export default __webpack_public_path__ + "static/media/Interface.6869fa05.svg";